/* @flow */

import React from 'react';
import { Message } from 'semantic-ui-react';

const View = () => (
  <Message
    icon="newspaper"
    header="Actualités"
    content={`Les actualités sont gérées via le module dédié de gestion d'actualités`}
  />
);

export default View;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/news/simple/View.js